/**
 * The first `popstate` listener on the window, so a page can hold the browser's
 * Back button before the router hears of it.
 *
 * ⚠️ It only works by being first, which is why App.js imports this file above
 * everything that mounts a router. Chrome runs the listeners of an event fired
 * at `window` in the order they were added, capture or not, and React treats
 * `popstate` as a click: the router's listener would unmount the page before a
 * listener added by that page ever ran.
 *
 * Does nothing at all until a page calls `holdBackButton`.
 */
let held = null;

window.addEventListener("popstate", (event) => {
  if (!held) return;
  event.stopImmediatePropagation();
  held();
});

/** Calls `onBack` instead of letting the router move. Returns the undo. */
export function holdBackButton(onBack) {
  held = onBack;
  return () => {
    if (held === onBack) held = null;
  };
}
